import api from '../api';
import { defaultFetchConfig } from '../config';
import ranchApi from '../ranchApi';
import surveyApi from '../surveyApi';

export const fetchAllFieldDetails = async (params = {}) => {
  const { data = [] } = await ranchApi.get(`/admin/fields`, {
    params: { ...defaultFetchConfig, ...params }
  });
  return data;
};

export const fetchAllMetricData = async (params = {}) => {
  try {
    const { data = {} } = await ranchApi.get(`/admin/project/metrics`, {
      params
    });
    return data;
  } catch (error) {
    console.error('fetchAllMetricData error:', error);
    throw error;
  }
};
export const fetchFieldById = async (params = {}) => {
  try {
    const { data = [] } = await ranchApi.get('getFieldById', {
      params
    });
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

export const fetchAllProducers = async (params = {}) => {
  try {
    const { data = [] } = await ranchApi.get(`/getAllProducers`, {
      params
    });
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

export const fetchBankDocEnum = async (params = {}) => {
  try {
    const { data = [] } = await api.get(`/enum/values?type=bank_document_type`, {
      params
    });
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

export const fetchBankFarmers = async (params = {}) => {
  try {
    const { data = [] } = await api.get('/farmers/bank', {
      params
    });
    return data;
  } catch (error) {
    console.error('fetchBankFarmers error:', error);
    throw error;
  }
};

export const fetchSurveyList = async (params) => {
  try {
    const res = await surveyApi.get(`/v1/admin/surveys`, { params });
    return {
      data: res?.data,
      totalRecords: res?.headers['x-coreplatform-total-records']
    };
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

export const fetchSurveyDeatils = async (surveyId, params) => {
  try {
    const res = await api.get(`/survey/${surveyId}/farms`, {
      params
    });
    return {
      data: res?.data,
      totalRecords: res?.headers['x-coreplatform-total-records']
    };
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

export const fetchSurveyFieldDeatils = async (fieldId, surveyId) => {
  try {
    const { data } = await surveyApi.get(`/v1/admin/field/${fieldId}/survey/${surveyId}`);
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};
